module.exports = __webpack_public_path__ + "static/media/smoking CessationActive.3fba0da5.svg";